import { Redirect } from 'expo-router';

import { routes } from 'navigation/routing';
import { LoyaltyHistory } from 'pages/loyalty/loyalty-history/loyalty-history';
import { LoyaltyRewardsTabs } from 'pages/loyalty/loyalty-rewards/loyalty-rewards-tabs';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

export default function RewardsHistoryRoute() {
  const enableLoyaltyProfile = useFlag(LaunchDarklyFlag.ENABLE_LOYALTY_PROFILE);

  if (enableLoyaltyProfile) {
    return <Redirect href={routes.history} />;
  }

  return (
    <>
      <LoyaltyRewardsTabs />
      <LoyaltyHistory />
    </>
  );
}
